"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MutationFunctionHandler = _interopRequireDefault(require("./MutationFunctionHandler"));

/**
 * A MutationFunctionHandler for deletions.
 */
class DeleteFunctionHandler extends _MutationFunctionHandler.default {
  constructor() {
    super('DELETE', true);
  }

}

exports.default = DeleteFunctionHandler;